angular.module('gym.waivers').controller('CopyWaiverToGymCtrl', ["$scope", "Restangular", "$stateParams", "$modalInstance", "$timeout", "$http", "flash", "waiver", function($scope, Restangular, $stateParams, $modalInstance, $timeout, $http, flash, waiver) {
  var Subscribers, allSubscribers;
  $scope.waiver = waiver;
  Subscribers = Restangular.all('gyms', $stateParams.gymId).all('subscribers');
  allSubscribers = Subscribers.getList({
    count: 1000
  }).$object;
  $scope.pageParams = {
    selectedGym: [],
    gymEmail: ''
  };
  $scope.getGyms = function(value) {
    if (!value) {
      return allSubscribers;
    }
    return Subscribers.getList({
      search: value
    }).then(function(gyms) {
      return gyms;
    });
  };
  $scope.selectGym = function(gym) {
    $scope.pageParams.selectedGym = [gym];
    return $timeout(function() {
      return document.getElementById('copyWaiverGymEmail').focus();
    }, 500);
  };
  $scope.removeGym = function() {
    return $scope.pageParams.selectedGym = [];
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.isReady = function() {
    return $scope.pageParams.selectedGym.length && $scope.pageParams.gymEmail.trim();
  };
  return $scope.submit = function() {
    var params, url;
    if ($scope.pageParams.gymEmail.trim() !== $scope.pageParams.selectedGym[0].payor_email) {
      $scope.error = "Email confirmation does not match";
      return;
    }
    $scope.isLoading = true;
    url = `gyms/${$stateParams.gymId}/waivers/waivers/${waiver.id}/copy_to_gym`;
    params = {
      target_gym_id: $scope.pageParams.selectedGym[0].id,
      target_gym_email: $scope.pageParams.gymEmail.trim()
    };
    return $http.put(url, params).then(function() {
      flash.success = "Waiver copied successfully";
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error;
      flash.error = "There was an error processing the request.";
      return $scope.isLoading = false;
    });
  };
}]);
